import state from './overviewState'
import { mutations, actions, getters } from './overview'
import { buildUrl } from '../../helpers'
export default {
    state() {
        return {
            ...state,
            defaultFavorite: [
                'informations_email', 'informations_phone', 'third_0_name', 'third_0_fullName',
            ],
            csrfToken: null
        }
    },
    mutations: {
        ...mutations,
        buildFavorites(state, { getters }) {
            const groupWithFavorites = ['informations', 'third']

            _.each(groupWithFavorites, (groupName) => {
                if (getters[groupName] && getters[groupName].length > 0){
                    _.each(getters[groupName], (itemGroup) => {
                        if (itemGroup.data && itemGroup.data.length > 0){
                            // for linked third on people overview
                            _.each(itemGroup.data, (itemData) => {
                                if (getters['activeFavorites'].includes(itemData.favoriteName)) {
                                    state.favorites.push(itemData)
                                }
                            })
                        } else{
                            if (getters['activeFavorites'].includes(itemGroup.favoriteName)) {
                                state.favorites.push(itemGroup)
                            }
                        }
                    })
                } else {
                    _.each(state.dataMap[groupName], (itemGroup) => {
                        const favoriteNameBuilded = buildUrl(itemGroup.favoriteName, [{ key: 'position', value: 0 }])
                        if (getters['activeFavorites'].includes(favoriteNameBuilded)) {
                            if (favoriteNameBuilded.indexOf('third_0') > -1){
                                itemGroup.label = itemGroup.label+ Loc.g(' (Société 1)')
                            }
                            itemGroup.value = '-'
                            itemGroup.link = 'javascript:;'
                            state.favorites.push(itemGroup)
                        }
                    })
                }
            })
        },
        setCsrfToken(state, csrfToken) {
            state.csrfToken = csrfToken;
        }
       
    },
    actions: {
        ...actions,
        updateCsrfToken: ({commit}, csrfToken) => {
            commit('setCsrfToken', csrfToken);
        }
    },
    getters: {
        ...getters,
        informations: state => {
            state.dataMap.informations.map(map => {
                const info = state.dataFetch.informations.find(info => info.key == map.id);
                map.value = info !== undefined ? info.value : ''
                map.linkedtype = state.linkedtype
                map.linkedid = state.linkedid

            })
            return state.dataMap.informations
        },
        third: state => {
            const thirdsData = []
            if (state.dataFetch.thirds.length > 0) {
                let cpt = 1
                let index = 0
                state.dataFetch.thirds.map(third => {
                    const dataThird = {
                        name: Loc.g("Société") + ' ' + cpt,
                        data: []
                    }
                    const currentMapping = JSON.parse(JSON.stringify(state.dataMap))
                    currentMapping.third.map(map => {
                        if (map.level && third[map.level] !== undefined && third[map.level] !== null) {
                            map.value = third[map.level][map.id] !== undefined ? third[map.level][map.id] : ''
                            if (map.id == 'fullName' && third[map.level]['position'] && third[map.level]['position'] != '') {
                                map.value += ' (' + third[map.level]['position'] + ')'
                            }
                            if (third[map.level]['link'] !== undefined && third[map.level]['link'] != '') {
                                map.link = third[map.level]['link']
                            }
                        } else {
                            map.value = third[map.id] !== undefined ? third[map.id] : ''
                            map.link = third['link'] !== undefined ? third['link'] : ''
                        }
                        map.forceLabel = map.label + ' (' + dataThird.name+')'
                        map.favoriteName = buildUrl(map.favoriteName, [{ key: 'position', value: index }])
                        dataThird.data.push(map)
                    })
                    thirdsData.push(dataThird)
                    cpt++
                    index++
                })

            }
            return thirdsData
        },
        csrfToken: state => state.csrfToken
    }
}